import { Controller } from '@hotwired/stimulus'
import { emit } from '../lib/events'

export default class extends Controller {
  static values = {
    emitable: String,
    hash: String,
  }

  connect = () => {
    this.handleLocation()
  }

  handleLocation = () => {
    if (this.anchor === this.hashValue) {
      emit(this.emitableValue, { bubbles: true })
    }
  }

  get anchor() {
    const currentUrl = new URL(document.location)

    return currentUrl.hash
  }
}
